export const legacyShootThemeRows = [
  { theme: 'Mock 테마 A', counts: { '2026-06': 4, '2026-07': 5, '2026-08': 6 } },
  { theme: 'Mock 테마 B', counts: { '2026-06': 2, '2026-07': 3, '2026-08': 2 } },
  { theme: 'Mock 테마 C', counts: { '2026-06': 1, '2026-07': 2, '2026-08': 3 } },
]
export const legacyShootThemeOffices = ['Mock 지점 01', 'Mock 지점 02']
export const legacyShootProducts = ['Mock 촬영 상품 A', 'Mock 촬영 상품 B']
